import { prependRoot } from "../../util/prependRoot.js";
import { getApiRoot } from "../../store/configureStore.js";
import axios from "axios";

const routePrefix = "/samenvatting/";

const SamenvattingApi = {
	get(tochtId) {
		const listByUrl = prependRoot(routePrefix + "/" + tochtId, getApiRoot());
		return axios.get(listByUrl, {
			headers: {
				'accept': 'application/json'
			}
		});
	}
};

export default SamenvattingApi;
